<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-6 searching">
                        <span class="h_page">Arah Kebijakan Tahunan</span> <br> <br>
                    </div>
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="row">
                    <div class="col-md-5">
                        <span class="huruf_input">Periode RPJMD</span>
                        <select v-model="rpjmd_id" @change="cari_data()" class="form-control">
                            <option value="" >-- Semua Periode --</option>
                            <option v-for="(data) in list_rpjmd" :key="data.rpjmd_id" v-bind:value="data.rpjmd_id">	{{data.periode}}</option>
                        </select>
                    </div>
                </div>
                <br>
            <!-- ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ TABLE ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success text-center kepala_table_f">
                            <!-- <th class="text-center" style="width: 5%">No.</th> -->
                            <th class="text-center" style="width: 5%">No</th>
                            <th class="text-center" style="width: 10%">Tahun</th>
                            <th class="text-center" style="width: 35%">Uraian Misi</th>
                            <th class="text-center" style="width: 35">Keterangan</th>
                            <th class="text-center" style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-if="cek_load_data">
                                <td colspan="5" class="text-center">
                                    <img src="images/loading-plan.gif" width="450px">
                                </td>
                            </tr>
                            <template v-if="!cek_load_data">
                                <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.arah_kebijakan_tahunan_id"> 
                                    <!-- <td class="text-center tabel_center">1.</td> -->
                                    <td class="text-center tabel_center">{{index+1}}</td>
                                    <td class="tabel_center text-center" >{{data.tahun}}</td>
                                    <td class="tabel_center" >{{data.uraian}}</td>
                                    <td class="text-justify tabel_center">{{data.keterangan}}</td>

                                    <td class="text-center tabel_center" >
                                        <button @click="selectRelasi(data)" class="btn bg-light-blue btn-xs waves-effect" title="Pilih Isu Strategis" data-toggle="modal" data-target="#m_pilih_isu_strategis">
                                            <i class="material-icons" >link</i>
                                        </button>
                                            &nbsp;
                                        <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                            <i class="material-icons" >create</i>
                                        </button>
                                            &nbsp;
                                        <button @click="removeData(data.arah_kebijakan_tahunan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                            <i class="material-icons" >clear</i>
                                        </button>
                                    </td>
                                </tr>

                            </template>

                        </tbody>
                    </table>
                </div>
            <!-- ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ TABLE ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
                <hr>
                    <div class="text-center">
                        <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                        </button>
                        &nbsp;
                        <span style="font-size: 85%; color: #a5a5a5">
                            <b>{{page_first}} - {{page_last}}</b>
                        </span>
                        &nbsp;
                        <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                        </button>
                    </div>
                <hr>




                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>
                            <form @submit.prevent="addData()">
                                <div class="modal-body">

    
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Tahun</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <select class="form-control" v-model="tahun">
                                                        <option v-for="data in list_tahun" :key="data.id" :value="data.tahun">{{data.tahun}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Uraian Tujuan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <textarea v-model="uraian" rows="4" class="form-control no-resize" placeholder="Masukan Uraian..."></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Keterangan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <textarea v-model="keterangan" rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <form @submit.prevent="editData()">
                                    <div class="modal-body">
                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Tahun</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <select class="form-control" v-model="tahun">
                                                            <option v-for="data in list_tahun" :key="data.id" :value="data.tahun">{{data.tahun}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Uraian Tujuan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <textarea v-model="uraian" rows="4" class="form-control no-resize" placeholder="Masukan Uraian..."></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Keterangan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <textarea v-model="keterangan" rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                        <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL PILIH ARAH KEBIJAKAN PEMBANGUNAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_pilih_isu_strategis" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">KETERKAITAN DENGAN ARAH KEBIJAKAN PEMBANGUNAN</h4>
                                </div>
                                <div class="modal-body">
                                    <button @click="getArahKebijakan" data-toggle="modal" data-target="#m_list_isu_strategis" class="btn bg-light-blue btn-xs waves-effect">Tambah data</button>
                                    <hr>
                                    
                                    <div class="table-responsive">
                                        <table class="table table-bordered" style="width: 100%">
                                            <thead>
                                                <tr class="bg-info text-center kepala_table_f">
                                                    <th class="text-center" style="width: 10%">No</th>
                                                    <th class="text-center" style="width: 75%">Uraian</th>
                                                    <th class="text-center" style="width: 15%">Pilih</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="h_isitable" v-for="data in list_arah_kebijakan_arah_kebijakan_tahunan" :key="data.relasi_id">
                                                    <td class="text-center">{{data.no_misi}}.{{data.no_arah_kebijakan}}</td>
                                                    <td >{{data.uraian_arah_kebijakan}}</td>
                                                    <td class="text-center">
                                                        <button @click="RemoveRelasi_arah_kebijakan_arah_kebijakan_tahunan(data.relasi_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data">
                                                            <i class="material-icons" >clear</i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                </div>
                                <div class="modal-footer">

                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL PILIH ARAH KEBIJAKAN PEMBANGUNAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST ARAH KEBIJAKAN PEMBANGUNAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_list_isu_strategis" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyRelasi()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">PILIH LIST ARAH KEBIJAKAN PEMBANGUNAN</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="table-responsive">
                                        <table class="table table-bordered" style="width: 100%">
                                            <thead>
                                                <tr class="bg-info text-center kepala_table_f">
                                                    <th class="text-center" style="width: 10%">No Isu</th>
                                                    <th class="text-center" style="width: 75%">Uraian Isu</th>
                                                    <th class="text-center" style="width: 15%">Pilih</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="h_isitable" v-for="(data) in list_arah_kebijakan" :key="data.arah_kebijakan_id">
                                                    <td class="text-center">{{data.no_misi}}.{{data.no_arah_kebijakan}}</td>
                                                    <td >{{data.uraian}}</td>
                                                    <td class="text-center">
                                                        <input type="checkbox" :id="data.arah_kebijakan_id" :value="data.arah_kebijakan_id" v-model="pilih_arah_kebijakan" class="filled-in chk-col-light-blue">
                                                        <label :for="data.arah_kebijakan_id"></label>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button @click="AddRelasi_arah_kebijakan_arah_kebijakan_tahunan()" type="button" class="btn btn-info waves-effect" >SIMPAN</button>
                                    <button @click="emptyRelasi()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST ARAH KEBIJAKAN PEMBANGUNAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>

    </div>
</template>


<script>

    const ADD_URL_RPJMD = URL_APP+'api/v1/planning_rpjmd/';
    const ADD_URL = URL_APP+'api/v1/planning_arah_kebijakan_tahunan/';
    const ADD_URL_TAHUN = URL_APP+'api/v1/planning_tahun/';
    const ADD_URL_ARAH_KEBIJAKAN = URL_APP+'api/v1/planning_arah_kebijakan/';


    export default {
        name: "planning_urusan",
        data() {
            return {
                tahun: '',

                arah_kebijakan_tahunan_id: "",
                rpjmd_id: '',
                tahun: '',
                uraian: '',
                keterangan: '',
                
                list_data : [],
                list_rpjmd: [],
                list_tahun : [],
                list_arah_kebijakan : [],
                pilih_arah_kebijakan : [],
                list_arah_kebijakan_arah_kebijakan_tahunan : [],

                page_first : 1,
                page_last : 0,
                cari_value : '',
                cek_load_data : true,
            };
        },

        mounted() {
            this.getData();
            this.getDataRPJMD();
            this.getDataTahun();
            localStorage.sidemenu = 'planing';
            
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            getDataRPJMD: function(){
                fetch(ADD_URL_RPJMD+'readData', {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        data_ke : this.page_first,
                        cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_rpjmd) => {
                    this.list_rpjmd = data_rpjmd.data;
                })
            },
            getDataTahun: function(){
                fetch(ADD_URL_TAHUN, {
                    method : 'GET',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                }).then((res) => res.json()).then((res_data) => {
                    this.list_tahun = res_data;
                })
            },
            getData: function(){
                this.cek_load_data = true;
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        data_ke : this.page_first,
                      cari_value : this.rpjmd_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.list_data = res_data.data;
                    this.page_last = res_data.jml_data;
                    this.cek_load_data = false;
                //   //console.log(res_data);
                })
            },
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        rpjmd_id : this.rpjmd_id,
                        tahun : this.tahun,
                        uraian : this.uraian,
                        keterangan : this.keterangan
                    })
                }).then(res => res.json()).then((data_misi) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        arah_kebijakan_tahunan_id: this.arah_kebijakan_tahunan_id,
                        rpjmd_id: this.rpjmd_id,
                        tahun: this.tahun,
                        uraian: this.uraian,
                        keterangan: this.keterangan,
                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            getArahKebijakan: function(){
                fetch(ADD_URL_ARAH_KEBIJAKAN, {
                    method : 'GET',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                }).then((res) => res.json()).then((res_data) => {
                    var lister = this.list_arah_kebijakan_arah_kebijakan_tahunan
                    for (let j = 0; j < lister.length; j++) {
                        const element = lister[j].arah_kebijakan_id;
                        for( var i = 0; i < res_data.length; i++){ 
                            if ( res_data[i].arah_kebijakan_id == element) {
                                res_data.splice(i, 1); 
                            }
                        }
                    }
                    this.list_arah_kebijakan = res_data;
                })
            },
            selectData : function(data){
                this.arah_kebijakan_tahunan_id= data.arah_kebijakan_tahunan_id;
                this.rpjmd_id= data.rpjmd_id;
                this.tahun= data.tahun;
                this.uraian= data.uraian;
                this.keterangan= data.keterangan;
            },
            emptyData : function(){
                this.rpjmd_id= '';
                this.tahun= '';
                this.uraian= '';
                this.keterangan= '';
                this.list_arah_kebijakan_arah_kebijakan_tahunan = [];
            },
            selectRelasi : function(data){
                this.selectData(data);
                this.getDataRelasi_arah_kebijakan_arah_kebijakan_tahunan();
            },
            emptyRelasi : function(){
                this.pilih_arah_kebijakan = [];
            },
            getDataRelasi_arah_kebijakan_arah_kebijakan_tahunan: function(){
                fetch(ADD_URL+'viewRelasi_arah_kebijakan_arah_kebijakan_tahunan', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        arah_kebijakan_tahunan_id : this.arah_kebijakan_tahunan_id,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.list_arah_kebijakan_arah_kebijakan_tahunan = res_data
                    // console.log(res_data);
                })
            },
            AddRelasi_arah_kebijakan_arah_kebijakan_tahunan: function(){
                fetch(ADD_URL+'AddRelasi_arah_kebijakan_arah_kebijakan_tahunan', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara '+localStorage.token
                    },
                    body : JSON.stringify({
                        arah_kebijakan_tahunan_id : this.arah_kebijakan_tahunan_id,
                        arah_kebijakan_id : this.pilih_arah_kebijakan,
                    })
                }).then((data_misi) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getDataRelasi_arah_kebijakan_arah_kebijakan_tahunan();
                    // this.view_misi_dengan_isu_strategis(this.misi_id);
                });

                //console.log(this.pilih_arah_kebijakan);
            },
            RemoveRelasi_arah_kebijakan_arah_kebijakan_tahunan: function(id){
                fetch(ADD_URL+'RemoveRelasi_arah_kebijakan_arah_kebijakan_tahunan', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara '+localStorage.token
                    },
                    body : JSON.stringify({
                        id : id
                    })
                }).then((data_misi) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getDataRelasi_arah_kebijakan_arah_kebijakan_tahunan();
                    // this.view_misi_dengan_isu_strategis(this.misi_id);
                });
            },




            //PAGINASI
                alertku : function(type, title){
                    this.$swal({
                        type: type,
                        title: title,
                        showConfirmButton: false,
                        timer: 800
                    });
                },

                btn_prev : function(){
                    this.cek_load_data = true;
                    if(this.page_first>1){
                        this.page_first--
                    }else{
                        this.page_first = 1;
                    }
                    this.getData();
                },

                btn_next : function(){
                    this.cek_load_data = true;
                    if(this.page_first >= this.page_last){
                        this.page_first == this.page_last
                    }else{
                        this.page_first++;
                    }
                    this.getData();
                },

                cari_data : function(){
                    this.cek_load_data = true;
                    this.page_first = 1;
                    this.getData();
                }
            //PAGINASI
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
